import React from "react";
import { connect } from "react-redux";
import { openCloseMediaUpload, setVisibleUploadComponent, setUploadedImage, setUploadedDocument, createGalleryItem, createVideoGalleryItem, pollingForVideo } from "../../actions/media_upload";
import { getGalleryItemsForPatient } from '../../actions/gallery'
import firebaseApp from '../../firebase';
import FileUploader from "react-firebase-file-uploader";

import eventbus from '../../store/eventbus'

// Assets
import listSvg from "./images/galleryUploadIcons/list.svg"
import pictureSvg from "./images/galleryUploadIcons/picture.svg"
import uploadSvg from "./images/galleryUploadIcons/upload.svg"
import videoSvg from "./images/galleryUploadIcons/video-camera.svg"
import videoLoader from "./images/35.gif"

import * as types from '../../constants/ActionTypes';

@connect((store) => {
  return {
    ...store
  };
})
class MediaUploadContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        practice: this.props.app.practice,
        isUploading: false,
        uploadProgress: 0,
        itemsToUpload: [],
        itemCount: 0,
        videoUploading: false,
        isMediaEnabled: this.props.app.practice.mediaStorageAddonEnabled,
        video_percentage: null,
    }

    this.toggleMediaUploadComponent = this.toggleMediaUploadComponent.bind(this);
    this.handleUploadStart = this.handleUploadStart.bind(this)
    this.handleDocumentUploadStart = this.handleDocumentUploadStart.bind(this)
    this.handleProgress = this.handleProgress.bind(this)
    this.handleImageUploadSuccess = this.handleImageUploadSuccess.bind(this)
    this.handleDocumentUploadSuccess = this.handleDocumentUploadSuccess.bind(this)
    this.handleUploadError = this.handleUploadError.bind(this)
    this.customFileName = this.customFileName.bind(this)
  }

  componentDidMount() {
      console.log(this.props.media_upload);
  }

  componentWillReceiveProps(nextProps) {
    const { practice, video_percentage } = this.state
    if (nextProps.app.practice.mediaStorageAddonEnabled !== practice.mediaStorageAddonEnabled) {
        // id has changed - get new
        this.setState({
            practice: nextProps.app.practice,
            isMediaEnabled: nextProps.app.practice.mediaStorageAddonEnabled
        })
        // console.log('update the state.')
    }
    // console.log('update gallery.');
    if (nextProps.gallery.video_percentage !== undefined && nextProps.gallery.video_percentage !== video_percentage) {
        this.setState({
            video_percentage: nextProps.gallery.video_percentage,
        })
    }
  }

  toggleMediaUploadComponent(event, bool) {
    openCloseMediaUpload(bool);
    if(bool == false){
        this.setCurrentState("select")
        this.setState(oldState => ({
            uploadProgress: 0,
            itemsToUpload: [],
            itemCount: 0,
            documentsUploading: [],
            videoUploading: false,
            video_percentage: null,
        }));
    }
  } 

  setCurrentState(value){
    //   Check is practice is able to upload videos and docs
    // if(!this.state.isMediaEnabled && value !== "uploadPhoto" && value !== "select"){
    //     alert("Un-Authorised, Please contact us for more info")
    //     return
    // }
    setVisibleUploadComponent(value)
  }

    //Firebase Upload Handlers
    handleUploadStart(obj){
        this.setCurrentState("uploading")
        console.log("UPLOAD START", obj)
        this.setState(oldState => ({
            isUploading: true,
            itemsToUpload: [...oldState.itemsToUpload, obj]
        }));
    }

    handleUploadError(error){
        this.setState({
            isUploading: false
        });
        alert(error)
        console.error(error);
    }

    handleImageUploadSuccess = async filename => {
        // console.log("filename:",filename);
        const path = this.props.media_upload.uploadPath;
        // console.log(`${path}${filename}`);
        let app = firebaseApp.storage();
        // console.log('before maxUploadRetryTime', app.maxUploadRetryTime);
        // console.log('before maxOperationRetryTime', app.maxOperationRetryTime);
        app.setMaxOperationRetryTime(1200000)
        app.setMaxUploadRetryTime(600000)
        // console.log('after maxUploadRetryTime', app.maxUploadRetryTime);
        // console.log('after maxOperationRetryTime', app.maxOperationRetryTime);
        const downloadURL = await app
            .ref(`${path}`)
            .child(filename)
            .getDownloadURL();

        // console.log("downloadURL:", downloadURL)

        let imgObject = {
            filename: filename,
            uploadPath: path,
            downloadURL: downloadURL
        }

        setUploadedImage(imgObject)

        // SEND CREATED PHOTO TO API GALLERY
        let galleryPayload = {
            url: imgObject.downloadURL,
            scope: this.props.media_upload.scope,
            sessionType: this.props.media_upload.sessionType,
            patient_id: this.props.media_upload.session.patient,
            mediaType: "photo",
            parent: null,
            therpist: null
        }

        this.createItemInGallery(galleryPayload)
    }

    handleProgress(progress){
        this.setState({
            uploadProgress: progress
        });
    }

    customFileName(file){
      // console.log("Check state object", this.state.itemsToUpload);
      // console.log('File:',file);
      var filename = file.name.substring(0, file.name.lastIndexOf('.'));
      var extension = file.name.substring(file.name.lastIndexOf('.'), file.name.length);

      let uploadObject = {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        new_name: filename + '-' + Date.now() + extension,
        size: file.size,
        type: file.type,
        webkitRelativePath: file.webkitRelativePath
      };
      this.setState(oldState => ({
        isUploading: true,
        itemsToUpload: [...oldState.itemsToUpload, uploadObject]
      }));
      return uploadObject.new_name;
    }

    handleDocumentUploadStart(obj){
        this.setCurrentState("uploading")
        console.log("UPLOAD START", obj)
        // this.setState(oldState => ({
        //     isUploading: true,
        //     itemsToUpload: [...oldState.itemsToUpload, obj]
        // }));
    }

    handleDocumentUploadSuccess = async filename => {
        // console.log("filename:",filename);
        const path = this.props.media_upload.uploadPath;
        // console.log(`${path}${filename}`);
        let app = firebaseApp.storage();
        // console.log('before maxUploadRetryTime', app.maxUploadRetryTime);
        // console.log('before maxOperationRetryTime', app.maxOperationRetryTime);
        app.setMaxOperationRetryTime(1200000)
        app.setMaxUploadRetryTime(600000)
        // console.log('after maxUploadRetryTime', app.maxUploadRetryTime);
        // console.log('after maxOperationRetryTime', app.maxOperationRetryTime);
        const downloadURL = await app
        .ref(`${path}`)
        .child(filename)
        .getDownloadURL();

        // console.log("downloadURL:", downloadURL)

        let documentObject = {
            filename: filename,
            uploadPath: path,
            downloadURL: downloadURL
        }
        // console.log('Document Object', documentObject);
        // console.log('ItemToUploadObject', this.state.itemsToUpload);

        let fileName = this.state.itemsToUpload.filter((item) => {
          return item.new_name == filename;
        });
        // console.log('FileName:', fileName[0]);
        setUploadedDocument(documentObject)

        // SEND CREATED DOCUMENT TO API GALLERY
        let galleryPayload = {
            url: documentObject.downloadURL,
            scope: this.props.media_upload.scope,
            sessionType: this.props.media_upload.sessionType,
            patient_id: this.props.media_upload.session.patient,
            mediaType: "document",
            filename: fileName[0].name,
            parent: null,
            therpist: null
        }

        // console.log("galleryPayload:",galleryPayload);
        this.createItemInGallery(galleryPayload)
    }

    createItemInGallery(payload){
        let user = this.props.User.User;

        let count = this.state.itemCount + 1
        this.setState(oldState => ({
            itemCount: count,
        }));

        if (this.props.media_upload.parent) {
            payload.parent = user.id;
            payload.therapist = null;
        } else {
            payload.parent = null;
            payload.therapist = user.id;
        }
        // console.log("updateGalleryItem", payload)

        createGalleryItem(payload)
            .then(result => {
                // console.log('Result:', result);
                // console.log('Type:', payload.sessionType);
                // PUBLISH EVENT BUS COMPLETED
                if (payload.sessionType === 'note') {
                    eventbus.publish("writeGalleryIdInSession", result)    
                } else if (payload.sessionType === 'comment') {
                    eventbus.publish("writeGalleryIdInComment", result)
                }

                // console.log('Item Count:', this.state.itemCount);
                // console.log('Item To Upload:', this.state.itemsToUpload.length);
                if(this.state.itemCount == this.state.itemsToUpload.length){
                    this.props.dispatch(getGalleryItemsForPatient(this.props.media_upload.session.patient))
                    this.setState(oldState => ({
                        isUploading: false,
                        uploadProgress:0,
                        itemCount: 0,
                        itemsToUpload: []
                    }));
                    this.toggleMediaUploadComponent(false)
                }
            })
    }


    videoUploadHandler = (event) => {
        this.setCurrentState("uploading")

        let user = this.props.User.User;

        const data = new FormData()
        data.set('scope', this.props.media_upload.scope)
        data.set('sessionType', this.props.media_upload.sessionType)
        data.set('patient_id', this.props.media_upload.session.patient)
        data.set('mediaType', 'video')

        if (this.props.media_upload.parent) {
            data.set('parent', user.id)
            // data.set('therapist', null)
        } else {
            data.set('therapist', user.id)
            // data.set('parent', null)
        }
        data.append('videos', event.target.files[0])
        
        createVideoGalleryItem(data)
        .then(result => {
            // console.log("video result from media component", this.props.media_upload.currentVideoUploading)
            const currentVideoObj = this.props.media_upload.currentVideoUploading
            if(currentVideoObj.url == "Uploading Video"){
                // check in 10 seconds if url is there
                this.pollingForVideoUrl()
            } 
        })
    }

    pollingForVideoUrl = () => {
        this.setState(oldState => ({
            videoUploading: true,
            video_percentage: null
        }))
        setTimeout(()=>{
            const currentVideoObj = this.props.media_upload.currentVideoUploading
            // console.log(currentVideoObj);
            pollingForVideo(currentVideoObj.id)
            .then((result)=>{
                // console.log("POLLING RESULT", currentVideoObj.url)
                if (currentVideoObj.url == "Uploading Video") {
                    this.pollingForVideoUrl()
                } else if (currentVideoObj.url == "Failed to upload Video" || currentVideoObj.url == "Failed transcoding Video") {
                    // Notify User Video failed to upload
                } else {
                    // PUBLISH EVENT BUS COMPLETED
                    if (currentVideoObj.sessionType === 'note') {
                        eventbus.publish("writeGalleryIdInSession", currentVideoObj)    
                    } else if (currentVideoObj.sessionType === 'comment') {
                        eventbus.publish("writeGalleryIdInComment", currentVideoObj)
                    }
                    this.props.dispatch({
                        type: types.SET_VIDEO_UPLOAD_PERCENTAGE,
                        payload: null
                    });
                    this.props.dispatch(getGalleryItemsForPatient(this.props.media_upload.session.patient))
                    this.setState(oldState => ({
                        videoUploading: false
                    }))
                    this.toggleMediaUploadComponent(false)
                }
            })
        },5000)
    }

    progressBar = () => {
        if(this.state.uploadProgress > 0 || this.state.video_percentage > 0){
            return (
                <div className="progressUploader">
                    {this.showItemCount()}
                    <progress max="100" value={this.state.uploadProgress || this.state.video_percentage}></progress>
                    <div className="percentage">{this.state.uploadProgress || this.state.video_percentage} %</div>
                </div>
            ) 
        } else {
            return null
        }
    }

    showItemCount = () => {
        if(this.state.itemsToUpload.length > 1){
            return (
                <div className="itemCount">
                    { this.state.itemsToUpload.length == this.state.itemCount ? this.state.itemsToUpload.length: this.state.itemCount + 1} of {this.state.itemsToUpload.length}
                </div>
            ) 
        } else {
            return null
        }
    }

    videoLoader = () => {
        if(this.state.videoUploading){
            return (
                <div className="videoUploading">
                    <div>
                        <img src={videoLoader} />
                    </div>
                    <div className="processingText">Processing Video...</div>
                </div>
            ) 
        } else {
            return null
        }
    }

  render() {
    let selection
    if(this.props.media_upload.componentVisible == "select")
        {
            selection = (<div className="wrapper" >
                            <h5>ADD AN ATTACHMENT</h5>
                            <div className="selectionBlock">
                                <button className="selection" onClick={(e) => this.setCurrentState("uploadPhoto")}>
                                    <img src={pictureSvg} alt="picture button"/>
                                    <small>Photo</small>
                                </button>
                                <button className="selection" disabled={!this.state.isMediaEnabled ? true : false} onClick={(e) => this.setCurrentState("uploadVideo")}>
                                    <img src={videoSvg} alt="video button"/>
                                    <small>Video</small>
                                </button>
                                <button className="selection" disabled={!this.state.isMediaEnabled ? true : false} onClick={(e) => this.setCurrentState("uploadDocument")}>
                                    <img src={listSvg} alt="document button"/>
                                    <small>Document</small>
                                </button>
                            </div>
                            <div className={`enableFeatureBlock ${this.state.isMediaEnabled ? "" : "show"}`}>
                                TO ENABLE VIDEO & DOCUMENT ATTACHMENTS
                                <div> 
                                    <a href="mailto:info@specialt.co.za" target="_blank">CHAT TO US FOR MORE INFO</a>
                                </div>
                            </div>
                            <button onClick={(e) => this.toggleMediaUploadComponent(e, false)}>
                                Cancel
                            </button>
                        </div>)

        } else if (this.props.media_upload.componentVisible == "uploadPhoto"){

            selection = (<div className="wrapper photo">
                            <h6>UPLOAD PHOTO</h6>
                            <FileUploader
                                accept="image/*"
                                name="image-uploader-multiple"
                                randomizeFilename
                                storageRef={firebaseApp.storage().ref(this.props.media_upload.uploadPath)}
                                onUploadStart={this.handleUploadStart}
                                onUploadError={this.handleUploadError}
                                onUploadSuccess={this.handleImageUploadSuccess}
                                onProgress={this.handleProgress}
                                multiple
                            />
                            <button onClick={(e) => this.toggleMediaUploadComponent(e, false)}>
                                Cancel
                            </button>
                        </div>)

        } else if (this.props.media_upload.componentVisible == "uploadVideo"){

            selection = (<div className="wrapper video">
                            <h6>UPLOAD VIDEO</h6>
                            <input type="file"
                                id="avatar" name="avatar"
                                accept="video/*" onChange={this.videoUploadHandler}></input>
                            <small>NOTE: Video files are generally large files. <br/> Please ensure you're on Wifi & allow some time for the upload.</small>
                            <button onClick={(e) => this.toggleMediaUploadComponent(e, false)}>
                                Cancel
                            </button>
                        </div>)

        } else if (this.props.media_upload.componentVisible == "uploadDocument"){

            selection = (<div className="wrapper document">
                        <h6>UPLOAD DOCUMENT</h6>
                        <FileUploader
                            accept="application/pdf"
                            name="image-uploader-multiple"
                            filename={this.customFileName}
                            storageRef={firebaseApp.storage().ref(this.props.media_upload.uploadPath)}
                            onUploadStart={this.handleDocumentUploadStart}
                            onUploadError={this.handleUploadError}
                            onUploadSuccess={this.handleDocumentUploadSuccess}
                            onProgress={this.handleProgress}
                            multiple
                        />
                        <button onClick={(e) => this.toggleMediaUploadComponent(e, false)}>
                            Cancel
                        </button>
                    </div>)

        } else if (this.props.media_upload.componentVisible == "uploading"){

            selection = (<div className="wrapper uploading">
                        <img className="uploadIcon" src={uploadSvg} alt="uploading icon"/>
                        <h6>UPLOADING...</h6>
                        {this.progressBar()}
                        {this.videoLoader()}
                        <small>Do not close or lock your device <br/>to ensure a successful upload.</small>
                        <button onClick={(e) => this.toggleMediaUploadComponent(e, false)}>
                            Cancel
                        </button>
                    </div>)
        }


    return (
      <div
        id="mediaUploadContainer"
        className={this.props.media_upload.isOpen ? "open" : ""}
        style={{display: "none"}}
      >
        {selection}
      </div>
    );
  }
}

export default MediaUploadContent;



// WEBPACK FOOTER //
// ./src/components/therapist/MediaUpload.jsx